import Page from "../../framework/Page";
import ParentView from "../../framework/ParentView";
import CenterButtonView from "./CenterButtonView";

export default class BottomRowButtonContainer extends ParentView {
    /**
     * @param {string} parentId
     * @param {string} elementId
     * @param {Projection} projection
     * @param {PanAnimation} panAnimation
     */
    constructor(parentId, elementId, projection, panAnimation) {
        super(parentId, elementId);

        this.addView(new CenterButtonView(elementId, projection, panAnimation));
    }

    /**
     * @override
     */
    initializeView() {

        // <div class="bottom-row-button-container">
        //   <div id="centerOnCharacterButton" class="center-on-character-button" style="display:none;">
        //     <img src="images/ui_center_button.png" title="Center on Crew"/>
        //   </div>
        // </div>
  
        const parentElement = Page.getElement(this.parentId);
        Page.createElement('div', parentElement, this.getElementId(), 'bottom-row-button-container');

        super.initializeView();        
    }

}